import { render, staticRenderFns } from "./details-calendar-item.vue?vue&type=template&id=2931caba&scoped=true&"
import script from "./details-calendar-item.vue?vue&type=script&lang=js&"
export * from "./details-calendar-item.vue?vue&type=script&lang=js&"
import style0 from "./details-calendar-item.vue?vue&type=style&index=0&id=2931caba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2931caba",
  null
  
)

export default component.exports